import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../../State';
import { ResourceScheduleActionTypes } from '../../State/actions/resource-dispo/resource-schedule.actions';
import {
    getResourceScheduleLatestUpdatedAt,
    getResourceSchedulesFetched,
} from '../../State/selectors/resource-dispo/resource-schedule.selectors';
import { BaseEntityReloadResolver2 } from '../resolver.helper';

@Injectable({
    providedIn: 'root',
})
export class ResourceScheduleResolver extends BaseEntityReloadResolver2 {
    constructor(store: Store<State>) {
        super(getResourceSchedulesFetched, getResourceScheduleLatestUpdatedAt, ResourceScheduleActionTypes.Load, store);
    }
}
